export function translateErrorMessage(msg: string): string {
	if (!msg) {
		return msg;
	}

	if (msg.toLowerCase().includes('network error:')) {
		return 'Cannot connect to server'
	}

	if (msg.includes('ECONNREFUSED')) {
		return 'Cannot connect to database';
	}

	if (msg.includes('ENOTFOUND')) {
		return 'Cannot connect to database';
	}

	if (msg.includes('duplicate key error collection')) {
		return 'Cannot insert item due to name duplication';
	}

	return msg.replace('GraphQL error: ', '');
}

export const parseGraphQlError = (error: Error) => {
	const parts = error.message.replace('GraphQL error: ', '').split('::');
	const messageOnly = parts.length === 1;

	return {
		code: messageOnly ? undefined : parts[0],
		message: messageOnly ? parts[0] : parts[1]
	};
};

export const trialPeriodMsg = 'Trial period has expired';
